const CLIMATE_PREFIX = 'Module.Climate';

export const CLIMATE_FEATURES = {
  module: `${CLIMATE_PREFIX}`,
};
